import { render, staticRenderFns } from "./CardSmallText.vue?vue&type=template&id=1b34873c&scoped=true&"
import script from "./CardSmallText.vue?vue&type=script&lang=js&"
export * from "./CardSmallText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b34873c",
  null
  
)

export default component.exports